import { FC } from "react"
import { TravelersEditSuccess } from "../../../module/travelers/containers/editSuccess"

export const TravelersEditSuccessPage: FC = () => <TravelersEditSuccess />
